export class ObjectiveTarget {
  id: string;
  description?: string;
}

export class AddressType {
  id: number;
  description?: string;
}

export class Address {
  id: number;
  country?: string;
  province?: string;
  location?: string;
  floor?: string;
  postalCode: string;
  number: number;
  street: string;
  street1?: string;
  street2?: string;
  departure?: string;
  type: AddressType;
}

export class DocumentType {
  id: number;
  description?: string;
}

export class Gender {
  id: number;
  description?: string;
  code?: string;
}

export enum KnownGender {
  FEMENINO = "FEMENINO",
  MASCULINO = "MASCULINO"
}

export class NewGenericCodeDescription {
  code: string;
  description: string;
}

export class SportPosition {
  id: number;
  code?: string;
  description: string;
}

export class Sport {
  id: number;
  code?: string;
  description: string;
  instituteId?: number;
  positions?: SportPosition[];
}

export class ReferencialData {
  id: number;
  positionId: number;
  sportId: number;
  genderCode: string;

  dsHeight: number;
  lowerRangeHeight: number;
  middleHeight: number;
  upperRangeHeight: number;

  dsWeight: number;
  lowerRangeWeight: number;
  middleWeight: number;
  upperRangeWeight: number;

  dsBMI: number;
  lowerRangeBMI: number;
  middleBMI: number;
  upperRangeBMI: number;

  dsBoneMassIndex: number;
  lowerRangeBoneMassIndex: number;
  middleBoneMassIndex: number;
  upperRangeBoneMassIndex: number;

  dsSum6Folds: number;
  lowerRangeSum6Folds: number;
  middleSum6Folds: number;
  upperRangeSum6Folds: number;

  dsKgMuscularMass: number;
  lowerRangeKgMuscularMass: number;
  middleKgMuscularMass: number;
  upperRangeKgMuscularMass: number;

  dsKgFatMass: number;
  lowerRangeKgFatMass: number;
  middleKgFatMass: number;
  upperRangeKgFatMass: number;
  
  dsKgBoneMass: number;
  lowerRangeKgBoneMass: number;
  middleKgBoneMass: number;
  upperRangeKgBoneMass: number;
}

export class TelephoneType {
  id: number;
  description?: string;
}

export class Telephone {
  id: number;
  countryCode: number;
  areaCode: number;
  number: number;
  type: TelephoneType;
}

export interface BasicQuestionMetadata {
  id: number;
}

export interface QuestionMetadata {
  id: number;
  type?: string;
  data_type?: string;
  label?: string;
}

export interface BasicHistoryType {
  id: number;
  description?: string;
}

export interface HistoryType extends BasicHistoryType {
  description?: string;
  module_name?: string;
}

export class ExamType {
  id: number;
  description?: string;
}

export enum KnownStaffPosition {
  NUTRICIONISTA = "NUTRICIONISTA",
  EVALUADOR = "EVALUADOR",
  SECRETARIA = "SECRETARIA"
}

export class StaffPosition {
  id: number;
  description: string;
}

export class PersonSegment {
  id: number;
  code?: string;
  description?: string;
}

export class Activity {
  id: number;
  description?: string;
  met?: number;
}
